/* ============================================================
 * Pantalla del enlace permanente: /pase/{token}
 *
 * Para quien no descargó nada y solo tiene el enlace. También sirve al
 * personal del centro si el cliente les enseña el enlace en vez del QR.
 * ============================================================ */

import React, { useEffect, useState } from 'react';
import { api } from '../api.js';
import { Cargando, ErrorCarga } from './Comunes.jsx';
import { Pase } from './Pase.jsx';
import { clp, fechaLarga } from '../utiles/fechas.js';

export function VerPase({ token, go }) {
  const [estado, setEstado] = useState({ datos: null, cargando: true, error: null });
  // Cancelación en dos pasos, sin diálogos del navegador: primero se
  // pregunta en la propia página, luego se confirma.
  const [confirmando, setConfirmando] = useState(false);
  const [cancelando, setCancelando] = useState(false);
  const [avisoCancel, setAvisoCancel] = useState('');

  useEffect(() => {
    api.pase(token)
      .then((datos) => setEstado({ datos, cargando: false, error: null }))
      .catch((error) => setEstado({ datos: null, cargando: false, error }));
  }, [token]);

  const cancelar = async () => {
    setCancelando(true);
    setAvisoCancel('');
    try {
      const r = await api.cancelarPase(token);
      if (!r.ok) { setAvisoCancel(r.motivo); return; }
      // La misma página cuenta el desenlace: recargamos el pase, que ya
      // vendrá como cancelado.
      const datos = await api.pase(token);
      setEstado({ datos, cargando: false, error: null });
      setConfirmando(false);
    } catch (e) {
      setAvisoCancel(e.message);
    } finally {
      setCancelando(false);
    }
  };

  if (estado.cargando) return <div className="wrap confirm"><Cargando que="tu pase" /></div>;
  if (estado.error) {
    return (
      <div className="wrap confirm">
        <ErrorCarga error={estado.error} />
        <button className="btn ghost block" style={{ marginTop: 20 }}
                onClick={() => go('home')}>Ir al inicio</button>
      </div>
    );
  }

  const d = estado.datos;
  const sede = {
    nombre: d.sede, direccion: d.direccion,
    comuna: d.comuna, precio_tune: d.precio_tune,
  };

  // Un pase ya usado o una reserva cancelada se dicen claramente. Presentarse
  // en el centro con un pase que no vale y descubrirlo allí es peor que leerlo
  // aquí.
  const anulado = d.usado || d.estado === 'cancelada';

  return (
    <div className="wrap confirm">
      {anulado ? (
        <>
          <h1>{d.usado ? 'Pase ya utilizado' : 'Reserva cancelada'}</h1>
          <p className="c-sub">
            {d.usado
              ? 'Esta sesión ya se registró en el centro.'
              : 'Esta reserva fue cancelada y el pase ya no sirve.'}
          </p>
        </>
      ) : (
        <>
          <h1>Tu pase</h1>
          <p className="c-sub">Enséñalo al llegar a {d.comuna}.</p>
          <Pase pase={{ token, codigo: d.pase_codigo }} sede={sede}
                fecha={d.fecha.slice(0, 10)} hora={d.hora}
                equipo={d.equipo} cliente={d.cliente}
                precioFinal={d.precio_final} />
        </>
      )}

      <div className="resumen">
        <div className="res-row"><span className="k">Centro</span><span className="v">{d.sede}</span></div>
        <div className="res-row"><span className="k">Dirección</span><span className="v">{d.direccion}</span></div>
        <div className="res-row"><span className="k">Día</span><span className="v">{fechaLarga(d.fecha.slice(0, 10))}</span></div>
        <div className="res-row"><span className="k">Hora</span><span className="v">{d.hora}</span></div>
        <div className="res-row"><span className="k">Equipo</span><span className="v">{d.equipo}</span></div>
      </div>

      {!anulado ? (
        <div className="pay-note">
          El pago se realiza en el centro ({clp(d.precio_final ?? d.precio_tune)}
          {d.precio_final != null ? ', con tu descuento aplicado' : ''}). Llega 5 minutos antes.
        </div>
      ) : null}

      {d.estado === 'confirmada' ? (
        <div style={{ marginTop: 14, textAlign: 'center' }}>
          {!confirmando ? (
            <button className="link-btn" onClick={() => setConfirmando(true)}>
              Cancelar mi reserva
            </button>
          ) : (
            <>
              <p className="c-sub" style={{ marginBottom: 10 }}>
                ¿Seguro? Tu hora quedará libre para otra persona.
              </p>
              <button className="btn block" onClick={cancelar} disabled={cancelando}>
                {cancelando ? 'Cancelando…' : 'Sí, cancelar mi reserva'}
              </button>
              <button className="link-btn" onClick={() => { setConfirmando(false); setAvisoCancel(''); }}>
                No, la mantengo
              </button>
            </>
          )}
          <div className="err">{avisoCancel}</div>
        </div>
      ) : null}

      <button className="btn ghost block" onClick={() => go('home')}>Reservar otra sesión</button>
    </div>
  );
}
